<template>
    <div class="container container-no-padding">
        <div class="content-wrap">      
            <div class="payment-top" id="shipping_information_block">              
                <div class="payment-two-column-block">
                    <div class="column-6 info-about-packet">
                        <div class="accordion">
                            <div class="accordion-item">
                                <h2 class="accordion-header">
                                    <button class="accordion-button">{{ $helper.trans('Shipment_information') }}</button>
                                </h2>
                                <div class="accordion-collapse collapse" style="display: initial;">
                                    <div class="accordion-body">
                                        <div class="packet-box-info">
                                            <span class="packet-info-label mb-2"><strong>{{ $helper.trans('Total_packages') }}:</strong> {{ $store.state.packagesDimensions.length }}</span>
                                            <span class="packet-title" v-for="(packagesDimension, packageIndex) in $store.state.packagesDimensions" :key="packageIndex">
                                                {{ ($store.state.packagesDimensions.length > 1 ? (packageIndex +1) : '') }} {{ packageTypeName }} {{ packageLineDimensions(packagesDimension) }}
                                            </span> 
                                            <span class="packet-info-label"><strong>{{ $helper.trans('Service') }}: </strong>{{ $store.state.selectedShippingOption.serviceName }}</span>
                                            <span class="packet-info-label"><strong>{{ isImport ? $helper.trans('Give_until') : $helper.trans('Item_pickup') }}: </strong>{{ calculatedPickupTime }}</span>
                                            <span class="packet-info-label"><strong>{{ $helper.trans('Delivery') }}: </strong>{{ formattedDeliveryTime }}</span>
                                        </div>                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="column-6 payment-info">
                        <div class="payment-block payment-line">
                            <div class="payment-row">
                                <label class="item">{{ $helper.trans('Transporting') }}</label>
                                <span class="value">{{ parseFloat($store.state.detailedCosts.baseCost).toFixed(2) }}€</span>
                            </div>
                            <div class="payment-row" v-if="transportPayerText">
                                <label class="item">{{ transportPayerText }}</label>
                                <span class="value"></span>
                            </div>
                            <div class="payment-row" v-if="transportPayerText === false">
                                <label class="item">{{ $helper.trans('Fuel_surcharge') }}</label>
                                <span class="value">{{ parseFloat($store.state.detailedCosts.fuelCharges).toFixed(2) }}€</span>
                            </div>
                        </div>
                        <div class="payment-block payment-line">
                            <div class="payment-row payment-small-text" 
                                v-for="(charge, chargeIndex) in $store.state.detailedCosts.otherCharges"
                                :key="chargeIndex"
                            >
                                <label class="item">{{ charge.name }}</label>
                                <span class="value">{{ parseFloat(charge.amount).toFixed(2) }}€</span>
                            </div>
                            <div class="payment-row payment-small-text" v-if="taxPayerText">
                                <label class="item">{{ taxPayerText }}</label>
                                <span class="value"></span>
                            </div>
                        </div>
                        <div class="payment-block">
                            <div class="payment-row">
                                <label class="item">{{ $helper.trans('Price') }}</label>
                                <span class="value">{{ parseFloat($store.state.detailedCosts.totalCost).toFixed(2) }}€</span>
                            </div>
                            <div class="payment-row payment-line">
                                <label class="item">{{ $helper.trans('VAT') }}</label>
                                <span class="value">{{ parseFloat($store.state.detailedCosts.vat).toFixed(2) }}€</span>
                            </div>
                        </div>
                        <div class="payment-block payment-total-block">
                            <div class="payment-row">
                                <label class="item">{{ $helper.trans('In_all') }}</label>
                                <span class="value">{{ parseFloat($store.state.detailedCosts.totalCostWithVat).toFixed(2) }}€</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="send-block button-block payment-block-confirm">
                    <button @click="backStep();" class="btn btn-border radius-4">{{ $helper.trans('Back') }}</button>
                </div>
            </div>  
        </div>
    </div>
</template>

<script>
import store from "../../../store";

export default {
    store,
    methods: {
        backStep: function(){
            this.$store.state.returnedBackFromPayment = true;
            this.$store.state.calculatorState = 'serviceSelector';
        },     
        packageLineDimensions: function(packagesDimension){
            let text = `${packagesDimension.weight}kg`;
            if(this.$store.state.packageType !== '02'){
                return text;
            } 
            return text + ` (${packagesDimension.length}cm x ${packagesDimension.width}cm x ${packagesDimension.height}cm)`;
        },
        clickUnregisteredCompanyInformationRadio: function(type){
            if(this.$store.state.unregisteredCompanyInformation.type === type){
                this.$store.state.unregisteredCompanyInformation.type = '';
            }
            this.$forceUpdate();
        },
    },    
    computed: {
        packageType(){
            let map = {
                '01': this.$helper.trans('Envelope'),
                '02': this.$helper.trans('Box'),
                '04': this.$helper.trans('UPS_Package'),
            };
            return map[this.$store.state.packageType] || '';
        },
        calculatedPickupTime(){
            if(this.isImport){
                return moment(this.$store.state.selectedShippingOption.estimatedPickup)
                    .locale(this.$store.state.$siteSettings['current_lang'])
                    .format(`L[, ${this.$helper.trans('until')}] LT`);
            }
            
            if(empty(this.$store.state.carrierInfo.callCarrier)){
                return this.$helper.trans('deliver_myself');
            }

            return `${this.$store.state.carrierInfo.carrierDate} ${this.$store.state.carrierInfo.carrierTimeFrom}-${this.$store.state.carrierInfo.carrierTimeTo}`;
        },
        formattedDeliveryTime(){
            return moment(this.$store.state.selectedShippingOption.estimatedDelivery)
                .locale(this.$store.state.$siteSettings['current_lang'])
                .format(`L[, ${this.$helper.trans('until')}] LT`)
                .replace('23:30', this.$helper.trans('end_of_work'))
        },
        transportPayerText(){
            let text = false;

            if(this.$store.state.majorPaymentType === 'prepaid'){
                return text;
            }

            if(this.$store.state.differentPaymentInformation.payer === 'receiver'){
                text = `${this.$helper.trans('Receiver_pays_transport')} ${this.$store.state.differentPaymentInformation.payerCode}`;
            } else if(this.$store.state.differentPaymentInformation.payer === 'third_party'){
                text = `${this.$helper.trans('Third_party_pays_transport')} ${this.$store.state.differentPaymentInformation.payerCountry.toUpperCase()} ${this.$store.state.differentPaymentInformation.payerCode}`;
            }

            return text;
        },
        taxPayerText(){
            let text = false;

            if(this.$store.state.majorPaymentType === 'prepaid' || this.$helper.insideEu() || this.$store.state.otherDeliveryInformation.isDocuments || this.$helper.isToIreland()){
                return text;
            }

            if(this.$store.state.differentPaymentInformation.payer !== 'sender' && this.$store.state.differentPaymentInformation.importPayer === 'sender'){
                return this.$helper.trans('SHIPPER_PAYS_DUTY_TAX');
            }

            if(this.$store.state.differentPaymentInformation.importPayer === 'receiver'){
                text = this.$helper.trans('Receiver_pays_tax');
                if(!empty(this.$store.state.differentPaymentInformation.importPayerCode)){
                    text += ' ' + this.$store.state.differentPaymentInformation.importPayerCode;
                }
            } else if(this.$store.state.differentPaymentInformation.importPayer === 'third_party'){
                text = `${this.$helper.trans('Third_party_pays_tax')} ${this.$store.state.differentPaymentInformation.importPayerCountry.toUpperCase()} ${this.$store.state.differentPaymentInformation.importPayerCode}`;
            }

            return text;
        },
        packageTypeName(){
            return (this.$store.state.packageType !== '04' ? this.packageType.toLowerCase() : this.packageType)
        },
        isImport(){
            return this.$store.state.to.country === 'lt';
        },
    },

}
</script>
